import { auth } from "application/auth/authReducer";
import { changeEmail } from "application/changeEmail/changeEmailReducer";
import { config } from "application/config/configReducer";
import { customer } from "application/customer/customerReducer";
import { cutoff } from "application/cutoff/cutoffReducer";
import { deleteAccount } from "application/deleteAccount/deleteAccountReducer";
import { delivery } from "application/delivery/deliveryReducer";
import { locale } from "application/locale/localeReducer";
import { menu } from "application/menu/menuReducer";
import { merchandise } from "application/merchandise/merchandiseReducer";
import { monAlbumPhotoArchive } from "application/monAlbumPhotoArchive/monAlbumPhotoArchiveReducer";
import { orders } from "application/order/orderReducer";
import { reorder } from "application/reorder/reorderReducer";
import { projects } from "application/savedProjects/projectReducer";
import { storage } from "application/storage/storageReducer";
import { widget } from "application/widget/widgetReducer";
import { combineReducers } from "redux";

export const indexReducer = combineReducers({
  auth,
  changeEmail,
  deleteAccount,
  config,
  customer,
  locale,
  orders,
  merchandise,
  widget,
  storage,
  delivery,
  reorder,
  projects,
  menu,
  monAlbumPhotoArchive,
  cutoff
});
